import { Col } from 'antd';
import { fieldSortOptions } from './FieldSortOptions';
import React from 'react';
import { ApiCodeToggle, SearchFilter, SearchFilterContainer, SortByFilter, TagFilter } from '../filters';
import { useSonarObjectReference } from '@hooks';
export const PeriscopeFieldSearch = ({ onChange, queryParams, sonarObjectId }) => {
    var _a;
    const showPopulation = (_a = useSonarObjectReference(sonarObjectId !== null && sonarObjectId !== void 0 ? sonarObjectId : 0)) === null || _a === void 0 ? void 0 : _a.hasFieldSpyMetadata;
    const sortOptions = sonarObjectId && showPopulation !== undefined ?
        fieldSortOptions.map((option) => (option.key === 'populationPercentage' ? Object.assign(Object.assign({}, option), { disabled: !showPopulation }) :
            option)) :
        fieldSortOptions;
    return (React.createElement(SearchFilterContainer, null,
        React.createElement(Col, { span: 12 },
            React.createElement(SearchFilter, { onChange: onChange })),
        React.createElement(Col, { className: 'align-right', span: 12 },
            React.createElement(ApiCodeToggle, { checked: Boolean(queryParams.useInternal), onChange: onChange })),
        React.createElement(Col, { span: 12 },
            React.createElement(TagFilter, { onChange: onChange })),
        React.createElement(Col, { className: 'align-right', span: 12 },
            React.createElement(SortByFilter, { defaultSortOption: fieldSortOptions[1], onChange: onChange, options: sortOptions, queryParams: queryParams }))));
};
